{
  "loading": "Carregando...",
  "placeholder": "Selecione uma opção..."
}
